<template>
    <div>
        <v-card elevation="0">
            <v-card-title>
                <v-icon color="#1B5E20">mdi-archive-search</v-icon>&nbsp;Search Data
            </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col md="3">
                            <v-card
                                elevation="0" color="#F1F8E9" height="750"
                            >
                                <v-card-text>
                                    <v-form @submit="getSearchResult" target="hiddenframe">
                                        <v-container>
                                            <v-row>
                                                <v-col
                                                    md="10"
                                                >
                                                    <v-text-field
                                                        v-model="searchTerm"
                                                        label="Enter Search term here"
                                                        prepend-inner-icon="mdi-magnify-scan"
                                                        clearable
                                                        dense
                                                        @keyup="validation"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col
                                                    md="1"
                                                >
                                                    <v-btn
                                                        type="submit"
                                                        color="#00ACC1"
                                                        :disabled="!submitbtn"
                                                        id="searchbtn"
                                                        icon
                                                        outlined
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-form>
                                    <v-card>
                                        <v-data-table
                                            :headers="headers"
                                            :items="employees"
                                            :loading="loading"
                                            :loading-text="loadingMsg"
                                            class="elevation-0"
                                        >
                                            <template v-slot:item.actions="{ item }">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            small
                                                            class="mr-2"
                                                            @click="viewData(item)"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-eye
                                                        </v-icon>
                                                    </template>
                                                    <span>View Graph</span>
                                                </v-tooltip>
                                            </template>
                                        </v-data-table>
                                    </v-card>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col md="9">
                            <v-card v-if="graphok" elevation="0">
                                <SearchedData :username="chosenUser" :faData="chosenUserData" :lastUpdated="lastUpdated"/>
                            </v-card>
                            <v-card v-else-if="!graphok" elevation="0">
                                <v-card-title class="text-center">Data view will appear here.</v-card-title>
                            </v-card>
                            <v-card v-if="noData" elevation="0">
                                <v-card-title>
                                    <v-alert type="warning" prominent>
                                        No data for the searched employee.
                                    </v-alert>
                                </v-card-title>
                            </v-card>
                        </v-col>
                    </v-row>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarColor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import SearchedData from "./SearchedData.vue";

export default {
    components: {
        SearchedData
    },
    data(){
        return {
            host: location.hostname.toString(),
            submitbtn: false,
            searchTerm: "",
            graphok: false,
            noData: false,
            username: false,
            loading: false,
            loadingMsg: "Searching...",
            headers: [
                {text: "EmpCode", value: "empcode"},
                {text: "Name", value: "employeename"},
                {text: "Action", value: "actions", sortable: false}
            ],
            employees: [],
            lastUpdated : "",
            chosenUser: "",
            chosenUserData: [],
            snackbar: false,
            text: "",
            timeout: 3500,
            snackbarColor: "#B2DFDB"
        }
    },
    methods: {
        validation(){
            const that = this;
            if(that.searchTerm.length < 3){
                that.submitbtn = false;
            }else {
                that.submitbtn = true;
            }
        },
        getSearchResult(){
            const that = this;

            let api= 'https://'+that.host+'/cgi-bin/fin-info-api/api.py?mode=searchuserdata&data={ "term" : "'+that.searchTerm+'" }';
            that.loading = true;
            that.noData = false;
            that.employees = [];
            
            //API GET request
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^ok/i)){
                        that.setSnackbar(resultData.result+": "+resultData.message, "#FF6F00");
                    }else {
                        if(resultData.data){
                            if(resultData.data.length == 0){
                                that.noData = true;
                                that.graphok = false;
                            }else {
                                that.noData = false;
                                that.lastUpdated = that.setTimeFormat_TS(parseInt(resultData.import["import-timestamp-js"]));
                                that.employees = resultData.data
                            }

                            that.setSnackbar("Data calling successful!", "#00695C");
                        }
                    }
                    that.loading = false;
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#D32F2F");
                })
            //End of API GET request 
        },
        setTimeFormat_TS(time){ //Uses Timestamp to convert to user-friendly date
            const that = this;
            var date = new Date(time);
            var stringDate = date.toLocaleString();

            return stringDate;
        },
        viewData(item){
            const that = this;
            //Disables the current view
            that.graphok = false;

            setTimeout(function() {
                //Re-renders the view with the new data
                that.chosenUserData = item;
                that.chosenUser = item.employeename;
                
                that.graphok = true;
            }, 300);
            
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.text = msg;
            that.snackbarColor = color;
        },
    }
}
</script>